module.exports = __webpack_public_path__ + "static/npckc3-8ad51a0d9f2fd861a100e6ff9ca243dd.png";